unit View.Erros_Catalogados.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils, UWeb.Enum;

type
  TFViewErros_CatalogadosEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lberro: TLabel;
    ederro: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientErros_CatalogadosGet: TXDataWebClient;
    Erros_CatalogadosDataset: TXDataWebDataSet;
    Erros_CatalogadosDatasetid: TIntegerField;
    Erros_CatalogadosDataseterro: TStringField;
    Erros_CatalogadosDatasetexcluido: TBooleanField;
    Erros_CatalogadosDatasetinclusao: TDateTimeField;
    Erros_CatalogadosDatasetalteracao: TDateTimeField;
    Erros_CatalogadosDatasetexclusao: TDateTimeField;
    cbexcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientErros_CatalogadosGetLoad(Response: TXDataClientResponse);
    procedure Erros_CatalogadosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure ederroClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure DesabilitarComponentes;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewErros_CatalogadosEdit: TFViewErros_CatalogadosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewErros_CatalogadosEdit }

procedure TFViewErros_CatalogadosEdit.btSaveClick(Sender: TObject);
var
  lMensagem : string;
begin
  if THelperServer.VerificarCampoVazio(ederro) then
  begin
    TUtils.SetErroClass('view_erros_catalogados_form_lberro', 'Insira o erro!');

    Exit;
  end;

  lMensagem := 'Tem certeza que deseja cadastrar esse erro?';

  if not FInserting then
    lMensagem := 'Tem certeza que deseja alterar esse erro?';

   if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, lMensagem)) then
  begin
    TUtils.ChamarDivLoading;

    if Erros_CatalogadosDataset.State in dsEditModes then
    begin
      Erros_CatalogadosDataset.Post;
      Erros_CatalogadosDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

class function TFViewErros_CatalogadosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewErros_CatalogadosEdit.DesabilitarComponentes;
begin
  btSave.Enabled := False;
  ederro.Enabled := False;
  cbexcluido.Enabled := False;
end;

procedure TFViewErros_CatalogadosEdit.ederroClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_erros_catalogados_form_lberro');
end;

procedure TFViewErros_CatalogadosEdit.InsertEntity;
begin
  Erros_CatalogadosDataset.Close;
  Erros_CatalogadosDataset.SetJsonData('{}');
  Erros_CatalogadosDataset.Open;
  Erros_CatalogadosDataset.Insert;
end;

class function TFViewErros_CatalogadosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewErros_CatalogadosEdit(AForm).FInserting := AInserting;
    TFViewErros_CatalogadosEdit(AForm).FId := AId;
    TFViewErros_CatalogadosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewErros_CatalogadosEdit(AForm).InsertEntity
    else
      TFViewErros_CatalogadosEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewErros_CatalogadosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewErros_CatalogadosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Erros_CatalogadosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Erros_CatalogadosDataset.EntitySetName
    )
  );
  XDataClientErros_CatalogadosGet.Get(Erros_CatalogadosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewErros_CatalogadosEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
  begin
    THelperServer.RemoverDiv('campos-controle');

    if not TUtils.PossuiPermissao(Erros_CatalogadosDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
      DesabilitarComponentes;
  end
  else
  begin
    if not TUtils.PossuiPermissao(Erros_CatalogadosDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
      DesabilitarComponentes;
  end;
end;

procedure TFViewErros_CatalogadosEdit.XDataClientErros_CatalogadosGetLoad(Response: TXDataClientResponse);
begin
  Erros_CatalogadosDataset.Close;
  Erros_CatalogadosDataset.SetJsonData(Response.Result);
  Erros_CatalogadosDataset.Open;
  
  Erros_CatalogadosDataset.Edit;  
end;

procedure TFViewErros_CatalogadosEdit.Erros_CatalogadosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);

      Erros_CatalogadosDataset.Edit;

      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FShowListProc;
end;

procedure TFViewErros_CatalogadosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewErros_CatalogadosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.erros_catalogados.form.lbid');
  lberro := TLabel.Create('view.erros_catalogados.form.lberro');
  lbexcluido := TLabel.Create('view.erros_catalogados.form.lbexcluido');
  lbinclusao := TLabel.Create('view.erros_catalogados.form.lbinclusao');
  lbalteracao := TLabel.Create('view.erros_catalogados.form.lbalteracao');
  lbexclusao := TLabel.Create('view.erros_catalogados.form.lbexclusao');
  btCancel := TButton.Create('view.erros_catalogados.form.btBack');
  btSave := TButton.Create('view.erros_catalogados.form.btSave');
  edid := TDBEdit.Create('view.erros_catalogados.form.edid');
  ederro := TDBEdit.Create('view.erros_catalogados.form.ederro');
  edinclusao := TDBEdit.Create('view.erros_catalogados.form.edinclusao');
  edalteracao := TDBEdit.Create('view.erros_catalogados.form.edalteracao');
  edexclusao := TDBEdit.Create('view.erros_catalogados.form.edexclusao');
  cbexcluido := TDBCheckBox.Create('view.erros_catalogados.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  Erros_CatalogadosDataset := TXDataWebDataSet.Create(Self);
  Erros_CatalogadosDatasetid := TIntegerField.Create(Self);
  Erros_CatalogadosDataseterro := TStringField.Create(Self);
  Erros_CatalogadosDatasetexcluido := TBooleanField.Create(Self);
  Erros_CatalogadosDatasetinclusao := TDateTimeField.Create(Self);
  Erros_CatalogadosDatasetalteracao := TDateTimeField.Create(Self);
  Erros_CatalogadosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientErros_CatalogadosGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lberro.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ederro.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbexcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Erros_CatalogadosDataset.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetid.BeforeLoadDFMValues;
  Erros_CatalogadosDataseterro.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetexcluido.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetinclusao.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetalteracao.BeforeLoadDFMValues;
  Erros_CatalogadosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientErros_CatalogadosGet.BeforeLoadDFMValues;
  try
    Name := 'FViewErros_CatalogadosEdit';
    Width := 439;
    Height := 198;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 8;
    lbid.Width := 27;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd.:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lberro.SetParentComponent(Self);
    lberro.Name := 'lberro';
    lberro.Left := 8;
    lberro.Top := 35;
    lberro.Width := 24;
    lberro.Height := 13;
    lberro.Caption := 'Erro:';
    lberro.HeightPercent := 100.000000000000000000;
    lberro.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 8;
    lbexcluido.Top := 62;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 216;
    lbinclusao.Top := 8;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 216;
    lbalteracao.Top := 35;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 216;
    lbexclusao.Top := 62;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 110;
    btCancel.Top := 95;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 8;
    btSave.Top := 95;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 85;
    edid.Top := 5;
    edid.Width := 100;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ederro.SetParentComponent(Self);
    ederro.Name := 'ederro';
    ederro.Left := 85;
    ederro.Top := 32;
    ederro.Width := 100;
    ederro.Height := 21;
    ederro.HeightPercent := 100.000000000000000000;
    ederro.TabOrder := 7;
    ederro.Text := 'ederro';
    ederro.WidthPercent := 100.000000000000000000;
    SetEvent(ederro, Self, 'OnClick', 'ederroClick');
    ederro.DataField := 'erro';
    ederro.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 285;
    edinclusao.Top := 5;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 285;
    edalteracao.Top := 32;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 285;
    edexclusao.Top := 59;
    edexclusao.Width := 100;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbexcluido.SetParentComponent(Self);
    cbexcluido.Name := 'cbexcluido';
    cbexcluido.Left := 85;
    cbexcluido.Top := 59;
    cbexcluido.Width := 100;
    cbexcluido.Height := 22;
    cbexcluido.Caption := 'cbexcluido';
    cbexcluido.ChildOrder := 13;
    cbexcluido.HeightPercent := 100.000000000000000000;
    cbexcluido.WidthPercent := 100.000000000000000000;
    cbexcluido.DataField := 'excluido';
    cbexcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Erros_CatalogadosDataset;
    DataSource.Left := 280;
    DataSource.Top := 96;
    Erros_CatalogadosDataset.SetParentComponent(Self);
    Erros_CatalogadosDataset.Name := 'Erros_CatalogadosDataset';
    Erros_CatalogadosDataset.AfterApplyUpdates := Erros_CatalogadosDatasetAfterApplyUpdates;
    Erros_CatalogadosDataset.EntitySetName := 'Erros_Catalogados';
    Erros_CatalogadosDataset.Connection := DMConnection.ApiConnection;
    Erros_CatalogadosDataset.Left := 336;
    Erros_CatalogadosDataset.Top := 96;
    Erros_CatalogadosDatasetid.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetid.Name := 'Erros_CatalogadosDatasetid';
    Erros_CatalogadosDatasetid.FieldName := 'id';
    Erros_CatalogadosDataseterro.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDataseterro.Name := 'Erros_CatalogadosDataseterro';
    Erros_CatalogadosDataseterro.FieldName := 'erro';
    Erros_CatalogadosDataseterro.Required := True;
    Erros_CatalogadosDataseterro.Size := 255;
    Erros_CatalogadosDatasetexcluido.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetexcluido.Name := 'Erros_CatalogadosDatasetexcluido';
    Erros_CatalogadosDatasetexcluido.FieldName := 'excluido';
    Erros_CatalogadosDatasetinclusao.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetinclusao.Name := 'Erros_CatalogadosDatasetinclusao';
    Erros_CatalogadosDatasetinclusao.FieldName := 'inclusao';
    Erros_CatalogadosDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Erros_CatalogadosDatasetalteracao.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetalteracao.Name := 'Erros_CatalogadosDatasetalteracao';
    Erros_CatalogadosDatasetalteracao.FieldName := 'alteracao';
    Erros_CatalogadosDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Erros_CatalogadosDatasetexclusao.SetParentComponent(Erros_CatalogadosDataset);
    Erros_CatalogadosDatasetexclusao.Name := 'Erros_CatalogadosDatasetexclusao';
    Erros_CatalogadosDatasetexclusao.FieldName := 'exclusao';
    Erros_CatalogadosDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    XDataClientErros_CatalogadosGet.SetParentComponent(Self);
    XDataClientErros_CatalogadosGet.Name := 'XDataClientErros_CatalogadosGet';
    XDataClientErros_CatalogadosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientErros_CatalogadosGet, Self, 'OnLoad', 'XDataClientErros_CatalogadosGetLoad');
    XDataClientErros_CatalogadosGet.Left := 224;
    XDataClientErros_CatalogadosGet.Top := 96;
  finally
    lbid.AfterLoadDFMValues;
    lberro.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ederro.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbexcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Erros_CatalogadosDataset.AfterLoadDFMValues;
    Erros_CatalogadosDatasetid.AfterLoadDFMValues;
    Erros_CatalogadosDataseterro.AfterLoadDFMValues;
    Erros_CatalogadosDatasetexcluido.AfterLoadDFMValues;
    Erros_CatalogadosDatasetinclusao.AfterLoadDFMValues;
    Erros_CatalogadosDatasetalteracao.AfterLoadDFMValues;
    Erros_CatalogadosDatasetexclusao.AfterLoadDFMValues;
    XDataClientErros_CatalogadosGet.AfterLoadDFMValues;
  end;
end;

end.
